export enum KnownResources {
  DevResources = 'Development Resources',
  Tutorial = 'Report Interpretation Tutorial',
  EBook = 'VitalSource EBook'
}


export interface CustomResource {
  projectId: number;
  introTextMessageId: number;
  bodyTextMessageId: number;
  nameMessageId: number;
  introText: string;
  bodyText: string;
  nameText: string;
}

export interface DevResource {
  surveyId: number;
  competencyId: number;
  parentCompetencyId: number;
  level: number;
  name: string;
  acronym: string;
  interpreted: boolean;
  visibilityOn: boolean;
  order: number;
  description: string;
  scoreHighMessage: string;
  scoreLowMessage: string;
  developmentTips: string;
  instructions: string;
  letterCode: string;
}
